<template>
  <div>
    <v-dialog v-model="g702_report" max-width="1200" persistent scrollable>
      <v-card :loading="loading">
        <v-card-title class="p-1">
          <v-col cols="9" style="font-size: 18px;padding:0px" class="text-center mt-1">
            <b style="color:#666666;">AIA DOCUMENT G702</b>
          </v-col>
          <v-col cols="3" class="text-right fs-12">{{report_header_name}}</v-col>
        </v-card-title>
        <v-divider class></v-divider>
        <v-card-text style="height: 100%;">
          <v-row dense>
            <v-col cols="5">
              <v-row dense class="report-header ml-1">
                <v-col cols="4" style="min-width: 35%;" class="text-right">TO(OWNER) :</v-col>
                <v-col cols="8" style="max-width: 65%">
                  <div
                    class="ml-1"
                    v-if="project_details && project_details.customer && project_details.customer.bill_to_company == true && project_details.bill_to"
                  >
                    <b>
                      {{ project_details && project_details.bill_to ? project_details.bill_to :""}}
                      <br />
                      {{project_details ? project_details.bill_to_address_1 ? project_details.bill_to_address_1 : '': '' }}
                      {{ project_details ? project_details.bill_to_address_2 ? ', ' +project_details.bill_to_address_2 : '': ''}}
                      <br />
                      {{( project_details ? project_details.bill_to_city_details ? '' +project_details.bill_to_city_details.city_name:'' : '' )}}
                      {{( project_details ? project_details.bill_to_state_details ? ', ' +project_details.bill_to_state_details.state_name:'' : '' )}}
                      {{( project_details ? project_details.bill_to_zip ? '-' +project_details.bill_to_zip:'' : '' )}}
                    </b>
                  </div>
                  <div class="ml-1" v-else>
                    <b>
                      {{project_details ? project_details.customer ? project_details.customer.full_name:'':''}}
                      <br />
                      {{project_details ? project_details.customer ? project_details.customer.address_line_1 ? project_details.customer.address_line_1 : '': '' : ''}}
                      {{project_details ? project_details.customer ? project_details.customer.address_line_2 ? ', ' +project_details.customer.address_line_2 : '': '' : ''}}
                      <br />
                      {{(project_details ? project_details.customer ? project_details.customer.city_details ? '' +project_details.customer.city_details.city_name:'' : '' :'' )}}
                      {{(project_details ? project_details.customer ? project_details.customer.state_details ? ', ' +project_details.customer.state_details.state_name:'' : '' :'' )}}
                      {{(project_details ? project_details.customer ? project_details.customer.zip ? '-' +project_details.customer.zip:'' : '' :'' )}}
                    </b>
                  </div>
                  <div></div>
                </v-col>
                <v-col cols="4" style="min-width: 35%;" class="mt-3 text-right">FROM(CONTRACTOR) :</v-col>
                <v-col cols="8" style="max-width: 65%" class="mt-3">
                  <b class="ml-1">{{company_details.name}}</b>
                </v-col>

                <v-col cols="4" style="min-width: 35%;">{{company_details.phone_number}}</v-col>
                <v-col cols="8" class style="max-width: 65%">
                  <b
                    class="ml-1"
                  >{{company_details.shipping_address_line_1}}{{company_details.shipping_address_line_2 ? ', '+company_details.shipping_address_line_2 :''}}</b>
                </v-col>

                <v-col cols="4" style="min-width: 35%;">{{company_details.fax_number}} (Fax)</v-col>
                <v-col cols="8" class style="max-width: 65%">
                  <b
                    class="ml-1"
                  >{{company_details.shipping_city_details.city_name}}, {{company_details.shipping_state_details.short_name}} {{company_details.shipping_zip}}</b>
                </v-col>
                <v-col cols="4" style="font-size: 16px;" class="mt-3">CONTRACT FOR :</v-col>
                <v-col cols="8" class="mt-3" style="max-width: 65%">
                  <b class="ml-1">{{project_details.p_name ? project_details.p_name : ''}}</b>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-row dense>
                <v-col cols="4" class="text-right">PROJECT :</v-col>
                <v-col cols="8" class>
                  <b>
                    {{project_details.p_name ? project_details.p_name :''}}
                    <br />
                    {{project_details.p_address_1}}{{project_details.p_address_2 ?', '+project_details.p_address_2:''}}
                    <br />
                    {{(project_details.city)? ''+project_details.city.city_name:''}}{{(project_details.state)? ', '+project_details.state.state_name:''}}{{project_details.p_zip? '-'+project_details.p_zip: ''}}
                  </b>
                </v-col>
                <v-col cols="4" class="mt-5 text-right">ARCHITECT :</v-col>
                <v-col cols="8" class="mt-5">
                  <b>{{project_details.architect_name}}</b>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4">
              <v-row dense>
                <v-col
                  cols="6"
                  class="text-right"
                  v-if="g702_change_report==false"
                >APPLICATION NUMBER :</v-col>
                <v-col cols="6" class v-if="g702_change_report==false">
                  <b>
                    <v-select
                      :items="invoice_list"
                      item-text="invoice_number"
                      item-value="generated_inv_id"
                      v-model="invoice_no"
                      hide-details
                      dense
                      style="margin-top:-5px"
                      @change="getTotalPage();getAllInvoiceData()"
                    ></v-select>
                  </b>
                </v-col>
                <v-col cols="6" class="text-right" v-if="g702_change_report==true">CHANGE ORDER:</v-col>
                <v-col cols="6" class v-if="g702_change_report==true">
                  <v-select
                    :items="change_order_list"
                    item-text="change_order"
                    item-value="change_order"
                    v-model="change_order_id"
                    hide-details
                    dense
                    style="margin-top:-5px"
                    @change="getTotalPage();getAllInvoiceData()"
                  ></v-select>
                </v-col>
                <v-col cols="6" class="text-right">PERIOD TO :</v-col>
                <v-col cols="6">
                  <b>{{period_to}}</b>
                </v-col>
                <v-col cols="6" class="text-right">PROJECT NO :</v-col>
                <v-col cols="6">
                  <b>{{project_details.project_id}}</b>
                </v-col>
                <v-col cols="6" class="text-right">CONTRACT DATE :</v-col>
                <v-col cols="6">
                  <b>{{contract_date}}</b>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="mt-2 mb-2"></v-divider>
          <v-row dense class="custom-font-for-print">
            <v-col>
              <v-row dense class="report-header2 ml-1">
                <v-col cols="12" class="mt-1">
                  <b style="font-size: 16px;">CONTRACTOR'S APPLICATION FOR PAYMENT</b>
                </v-col>
                <v-col cols="12" class="mt-2">
                  <v-simple-table dense class="custom-table-border">
                    <tbody>
                      <tr>
                        <td colspan="4" width="100%">CHANGE ORDER SUMMARY</td>
                      </tr>
                      <tr>
                        <td
                          colspan="2"
                          width="60%"
                        >Change Orders approved in previous months by Owner</td>
                        <td width="20%">ADDITIONS</td>
                        <td width="20%">DEDUCT</td>
                      </tr>
                      <tr>
                        <td width="60%" colspan="2" style="text-align: right;">TOTAL</td>
                        <td width="20%">{{total_change_order > 0 ? total_change_order :''}}</td>
                        <td width="20%">{{ 0 > total_change_order ? total_change_order :''}}</td>
                      </tr>
                      <tr>
                        <td colspan="2" width="60%">Approved this month</td>
                        <td width="20%"></td>
                        <td width="20%"></td>
                      </tr>
                      <tr>
                        <td width="30%">Number</td>
                        <td width="30%">Date Approved</td>
                        <td width="20%"></td>
                        <td width="20%"></td>
                      </tr>
                      <tr>
                        <td width="30%"></td>
                        <td width="30%"></td>
                        <td width="20%" style="text-align: right;"></td>
                        <td width="20%" style="text-align: right;"></td>
                      </tr>
                      <tr>
                        <td width="60%" colspan="2" style="text-align: right;">TOTALS</td>
                        <td width="20%" style="text-align: right;">
                          <b></b>
                        </td>
                        <td width="20%" style="text-align: right;">
                          <b></b>
                        </td>
                      </tr>
                      <tr>
                        <td width="80%" colspan="3">Net change by Change Orders</td>
                        <td width="20%" class style="text-align: right;">
                          <b></b>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
                <v-col cols="12" class="mt-4">
                  The undersigned Contractor certifies that to the best of the Contractor's knowledge,
                  information and belief the Work covered by this Application for Payment has been
                  completed in accordance with the Contract Documents, that all amounts have been
                  paid by the Contractor for Work for which previous Certificates for Payment were
                  issued and payments received from the Owner, and that current payment shown
                  herein is now due.
                </v-col>
                <v-col cols="12" class="mt-3">CONTRACTOR: {{company_details.name}}</v-col>
                <v-col cols="12" class="mt-3">
                  <span>
                    By :
                    <b>{{company_details.contact_person}}</b>
                  </span>
                  <span style="margin-left: 20px;">Date :</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="6">
              <v-row dense class="report-header2">
                <v-col
                  cols="12"
                  class="mt-1"
                >Application is made for Payment, as shown below, in connection with the Contract.</v-col>
                <v-col cols="12">Continuation Sheet, AIA Document G703, is attached.</v-col>
                <v-col cols="12" class="mt-4">
                  <v-simple-table dense class="custom-table-border">
                    <tbody>
                      <tr>
                        <td width="68%">
                          <b>1. ORIGINAL CONTRACT SUM</b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                        <td width="16%" class style="text-align: right;">
                          <b>${{original_contract_sum}}</b>
                        </td>
                      </tr>
                      <tr>
                        <td width="68%">
                          <b>2. NET CHANGE BY CHANGE ORDERS</b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                        <td width="16%" style="text-align: right;">
                          <b>${{total_change_order}}</b>
                        </td>
                      </tr>

                      <tr>
                        <td width="68%">
                          <b>3. CONTRACT SUM TO DATE (Line1+/-2)</b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                        <td width="16%" class="text-right">
                          <b>${{row3_g_702}}</b>
                        </td>
                      </tr>
                      <tr>
                        <td width="68%">
                          <b>
                            4. TOTAL COMPLETED AND STORED TO DATE
                            <br />
                            <span style="padding-left:80px;">(Column G on G703)</span>
                          </b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                        <td
                          width="16%"
                          style="text-align: right;"
                          :class="{
                          'error--text': total_completed < 0,
                          'primary--text':total_completed > 0,
                        }"
                        >
                          <b>${{getAmountFormat(total_completed)}}</b>
                        </td>
                      </tr>
                      <tr>
                        <td width="68%">
                          <b>5. RETAINAGE</b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                        <td width="16%" style="text-align: right;">
                          <b></b>
                        </td>
                      </tr>
                      <tr>
                        <td width="68%" style="padding-left: 40px;">
                          a. {{p_retainage}} % of completed Work
                          <br />
                          <span class="pl-15">(Column D+E on G703)</span>
                        </td>
                        <td
                          width="16%"
                          style="text-align: right;"
                          :class="{
                          'error--text': total_retainage < 0,
                          'primary--text':total_retainage > 0,
                        }"
                        >
                          <b>${{getAmountFormat(total_retainage)}}</b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                      </tr>
                      <tr>
                        <td width="68%" style="padding-left: 40px;">
                          b. {{p_retainage}} % of stored Material
                          <br />
                          <span class="pl-15">(Column F on G703)</span>
                        </td>
                        <td width="16%" style="text-align: right;">
                          <b></b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                      </tr>
                      <tr>
                        <td width="68%" style="padding-left: 40px;">
                          Total Retainage
                          <br />
                          <span class="pl-15">(Line 5a + 5b or Total in Column I of G703)</span>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                        <td
                          width="16%"
                          style="text-align: right;"
                          :class="{
                          'error--text': total_retainage < 0,
                          'primary--text':total_retainage > 0,
                        }"
                        >
                          <b>${{getAmountFormat(total_retainage)}}</b>
                        </td>
                      </tr>
                      <tr>
                        <td width="68%">
                          <b>6. TOTAL EARNED LESS RETAINAGE (Line 4 Less Line 5 Total)</b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                        <td
                          width="16%"
                          style="text-align: right;"
                          :class="{
                          'error--text': row6_g_702 < 0,
                          'primary--text':row6_g_702 > 0,
                        }"
                        >
                          <b>${{getAmountFormat(row6_g_702)}}</b>
                        </td>
                      </tr>

                      <tr>
                        <td width="68%">
                          <b>
                            7. LESS PREVIOUS APPLICATIONS FOR PAYMENT
                            <br />
                            <span style="padding-left:80px">(Line 6 from prior Certificate)</span>
                          </b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                        <td
                          width="16%"
                          style="text-align: right;"
                          :class="{
                          'error--text': row7_g_702 < 0,
                          'primary--text':row7_g_702 > 0,
                        }"
                        >
                          <b>${{getAmountFormat(row7_g_702)}}</b>
                        </td>
                      </tr>
                      <tr>
                        <td width="68%">
                          <b>
                            8. CURRENT PAYMENT DUE
                            <br />
                            <!-- <span style="padding-left:80px">Total Received: ${{sales_income}}</span> -->
                          </b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                        <td width="16%" class="text-right">
                          <b
                            :class="{
                          'error--text': row8_g_702 < 0,
                          'primary--text':row8_g_702 > 0,
                        }"
                          >${{getAmountFormat(row8_g_702)}}</b>
                        </td>
                      </tr>
                      <tr>
                        <td width="68%">
                          <b>
                            9. BALANCE TO FINISH, PLUS RETAINAGE
                            <br />
                            <span style="padding-left:80px">(Line 3 less line 6)</span>
                          </b>
                        </td>
                        <td width="16%" style="text-align: right;"></td>
                        <td width="16%" style="text-align: right;">
                          <b>${{row9_g_702}}</b>
                        </td>
                      </tr>
                      <tr>
                        <td width="100%" colspan="3">
                          <b style="display:inline-flex">
                            <span
                              style="margin-top:3px;"
                            >TOTAL PAYMENT RECEIVED TILL DATE : &nbsp;&nbsp;&nbsp;</span>
                            <span
                              style="margin-top:3px;margin-left:10px;"
                            >&nbsp;&nbsp;&nbsp; ${{sales_income_till_date}}</span>
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
                <v-col cols="12" class="mt-4">
                  <span>State of : Florida</span>
                  <span style="margin-left: 20px;">County of : Hillsborough</span>
                </v-col>
                <v-col cols="12">Subscribed and sworn to before me this</v-col>
                <v-col cols="12">Notary Public :</v-col>
                <v-col cols="12">My Commission expires :</v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="mt-4 mb-2"></v-divider>
          <v-row dense class="custom-font-for-print">
            <v-col cols="5">
              <v-row dense class="ml-1">
                <v-col cols="12" class="mt-1">
                  <b style="font-size: 16px;">ARCHITECT'S CERTIFICATE FOR PAYMENT</b>
                </v-col>
                <v-col cols="12">
                  In accordance with the Contract Documents, based on on-site
                  observations and the data comprising the above application,
                  the Architect certifies to the Owner that to the best of the
                  Architect's knowledge, information and belief the Work has
                  progressed as indicated, the quality of the Work is in
                  accordance with the Contract Documents, and the Contractor
                  is entitled to payment of the AMOUNT CERTIFIED.
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="6">
              <v-row dense>
                <v-col cols="10" style="text-align: right; margin-top: 8px;">AMOUNT CERTIFIED :</v-col>
                <v-col cols="2">
                  <v-divider style="margin-top: 25px;"></v-divider>
                </v-col>
                <v-col
                  cols="12"
                >(Attach explanation if amount certified differs from the amount applied for.)</v-col>
                <v-col cols="12">ARCHITECT</v-col>
                <v-col cols="9" style="margin-top: 12px;">By :</v-col>
                <v-col cols="3" style="margin-top: 12px;">Date :</v-col>
                <v-col cols="12">
                  This Certificate is not negotiable. The AMOUNT CERTIFIED is payable only to the Contractor named herein. Issuance, payment and
                  acceptance of payment are without prejudice to any rights of the Owner or Contractor under this Contract.
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="mt-3 mb-4"></v-divider>
          <v-row dense class="report-header2 ml-1 mt-2 custom-font-for-print">
            <v-col cols="2">
              <b>AIA DOCUMENT G702</b>
            </v-col>
            <v-col cols="10">APPLICATION AND CERTIFICATE FOR PAYMENT - MAY 1983 EDITION - AIA C 1983</v-col>
            <v-col
              cols="12"
            >THE AMERICAN INSTITUTE OF ARCHITECTS, 1735 NEW YORK AVENUE, NW, WASHINGTON, D.C. 20006</v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mt-2">
          <v-btn color="error" @click="invoice_no='0';closePopup()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            @click="loading=true;generateReport(false,false, 'excel'); "
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-file</v-icon>Excel
          </v-btn>
          <v-btn
            :loading="loading"
            @click="loading=true;generateReport('whole_page',true); "
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-printer</v-icon>Print
          </v-btn>
          <v-btn
            :loading="loading"
            @click="generateReport(false); is_send_report = false; preview_pdf_dialog = true;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-content-save-outline</v-icon>Sign Online
          </v-btn>
          <v-btn
            @click="preview_pdf_dialog = true; is_send_report = true; generateReport(false);"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-send</v-icon>Send for Signature
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="preview_pdf_dialog" max-width="800" persistent>
      <v-card :loading="preview_pdf_loading">
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <iframe :src="preview_page_link" frameborder="0" style="width:100%;height:800px"></iframe>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="error"
            @click="preview_pdf_dialog = false; user_sign_blob = []; customer_sign_blob = ''; active_page = 0;"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? email_dialog = true : signature_dialog = true"
            v-if="total_page == active_page"
            :loading="preview_pdf_loading"
          >Finish</v-btn>
          <v-btn
            v-else
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? generateReport(false) : signature_dialog = true;"
            :loading="preview_pdf_loading"
          >Next Page</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SendMailDialog
      :email_id="email_ids"
      :email_dialog="email_dialog"
      @closeDialog="closeSendMailDialog"
      @sendMail="sendMail"
    />
    <Signatura
      :customer_sign="customer_sign_blob"
      :active_page="active_page"
      @updateValue="updateParent"
      @clearValue="clearParent"
      :project_details="project_details"
      :signature_dialog="signature_dialog"
    />
    <v-overlay absolute :value="loading" style="z-index: 999">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
  </div>
</template>
 <script>
import { getCompanyDetails } from "../../plugins/helper";
import Signatura from "../projects/Signatura";
import SendMailDialog from "../projects/SendMailDialog";
import axios from "../../plugins/axios";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      preview_pdf_loading: false,
      total_page: "",
      active_page: 0,
      user_sign_blob: [],
      customer_sign_blob: "",
      signature_dialog: false,
      loading: false,
      is_send_report: false,
      email_ids: null,
      email_id_arr: [],
      email_ids_error: null,
      email_dialog: false,
      send_pdf_loading: false,
      items: [],
      company_details: getCompanyDetails(),
      preview_pdf_dialog: false,
      preview_page_link: "",
      total_balance: "",
      total_completed: "",
      total_current: "",
      total_previous: "",
      total_schedule: "",
      project_name: "",
      project_no: "",
      customer_name: "",
      application_date: "",
      period_to: "",
      row3_g_702: "",
      row6_g_702: "",
      row7_g_702: "",
      row8_g_702: "",
      row9_g_702: "",
      total_retainage: "",
      total_change_order: "",
      p_retainage: "",
      is_p_retainage: false,
      contract_date: "",
      sales_income: "",
      sales_income_till_date: "",
      only_change_order: "",
      change_order_list: [],
      invoice_list: [
        {
          amount: "0",
          invoice_number: "0",
          generated_inv_id: "0"
        }
      ],
      invoice_no: "0",
      change_order_id: "",
      original_contract_sum: ""
    };
  },
  props: [
    "g702_report",
    "project_details",
    "generate_invoice_project",
    "invoice_id",
    "g702_change_report",
    "report_header_name"
  ],
  watch: {
    g702_report: function(value) {
      this.change_order_list = [];
      if (value) {
        console.log("project_details", this.project_details);

        if (this.invoice_id) {
          this.invoice_no = this.invoice_id;
        }
        this.getData();
      }
    },
    generate_invoice_project: function(value) {
      if (value) {
        this.getData();
      }
    }
  },
  computed: {
    user_name() {
      return localStorage.getItem("user_name");
    }
  },
  components: {
    Signatura,
    SendMailDialog
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getAmountFormat(value) {
      if (value) {
        return value.replace("-", "");
      } else {
        return 0;
      }
    },
    getData() {
      if (this.project_details.project_work == "remodeling") {
        this.project_data_flag = 2;
      } else if (this.project_details.project_work == "new_construction") {
        this.project_data_flag = 1;
      } else if (this.project_details.project_work == "project_management") {
        this.project_data_flag = 4;
      }
      this.preview_page_link = "";
      this.active_page = 0;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      // this.getReportDetails();
      if (this.g702_change_report == true) {
        this.getChangeOrderList();
      } else {
        this.getInvoiceList();
      }
      setTimeout(() => {
        this.getTotalPage();
      }, 2000);
    },
    sendMail(variable) {
      this.email_id_arr = variable;
      this.sendSalesInvoiceReport();
    },
    closeSendMailDialog() {
      this.email_dialog = false;
      this.preview_pdf_dialog = false;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      this.active_page = 0;
    },
    updateParent(variable) {
      if (variable.user_sign_blob) {
        this.user_sign_blob.push({
          page: this.active_page,
          sign_blob: variable.user_sign_blob
        });
      }
      if (variable.customer_sign_blob && this.active_page == 1) {
        this.customer_sign_blob = variable.customer_sign_blob;
      }
      this.signature_dialog = false;
      if (this.is_send_report) {
        if (this.total_page == this.active_page) {
          this.email_dialog = true;
          this.email_ids =
            this.project_details.customer.email +
            "@" +
            this.project_details.customer.email_domain.domain;
        } else {
          this.generateReport(false);
        }
      } else {
        if (this.total_page == this.active_page) {
          this.generateReport(true);
        } else {
          this.generateReport(false);
        }
      }
    },
    clearParent(variable) {
      console.log(variable);
      this.signature_dialog = false;
    },
    closePopup() {
      this.$emit("updateValue");
    },
    getTotalPage() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      var formData = new FormData();
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("generate_pdf_flag", "get_total");
      formData.append("project_data_flag", this.project_data_flag);
      formData.append("report_name", "g_702");
      formData.append("report_header_name", this.report_header_name);
      this.loading = true;
      axios
        .post("generate_report_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });
    },
    // generatePrint(){
    //   let company_data = localStorage.getItem('company_data')
    //   company_data = JSON.parse(company_data)
    //   var formData = new FormData();
    //   formData.append('generate_pdf_flag','whole_page')
    // },

    generateReport(is_past_page, direct_print = false, $excel = "") {
      this.preview_pdf_loading = true;
      this.active_page++;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      // let url = 'flag=save&project_id='+this.project_details.project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&sign='+this.sign_blob;
      var formData = new FormData();

      if (is_past_page) {
        if (this.user_sign_blob) {
          for (let key in this.user_sign_blob) {
            formData.append(
              `user_sign_blob[${this.user_sign_blob[key].page}]`,
              this.user_sign_blob[key].sign_blob
            );
          }
        }
        if (this.customer_sign_blob) {
          formData.append(`customer_sign_blob`, this.customer_sign_blob);
        }
        formData.append("generate_pdf_flag", "whole_page");
      } else {
        formData.append("generate_pdf_flag", "single_page");
      }
      formData.append("flag", "save");
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("total_page", this.total_page);
      formData.append("active_page", this.active_page);
      formData.append("project_data_flag", this.project_data_flag);
      formData.append("report_name", "g_702");
      formData.append("report_header_name", this.report_header_name);
      formData.append("direct_print", direct_print);
      formData.append("generate_invoice_id", this.invoice_no);
      formData.append("g702_change_report", this.g702_change_report);
      formData.append("g702_change_order_id", this.change_order_id);
      formData.append("is_excel", $excel);
      axios
        .post("generate_report_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.is_excel == true) {
            this.preview_pdf_loading = false;
            this.loading = false;
            window.open(response.data.file_url, "_blank");
          } else {
            if (is_past_page) {
              if (response.data.status) {
                if (direct_print) {
                  var File_url = response.data.file_url;
                  window.open(File_url, "Download");
                  this.loading = false;
                } else {
                  this.setAlert({
                    show: true,
                    variant: "primary",
                    message: response.data.message,
                    dismissCountDown: 0
                  });
                  this.closePopup();
                }
                this.preview_pdf_dialog = false;
              }
            } else {
              this.preview_pdf_loading = false;
              this.preview_page_link = response.data.preview_page_link;
            }
            this.preview_pdf_loading = false;
          }
        })
        .catch(function(error) {
          console.log(error);
          this.preview_pdf_loading = false;
        });

      // let url = 'flag=save&project_id='+this.project_details.project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&sign='+this.sign_blob;
      // this.loading = true;
      // axios
      // .get("generate_sales_invoice_pdf?" + url)
      // .then(response => {
      //   if(response.data.status) {
      //     this.setAlert({
      //       show: true,
      //       variant: "primary",
      //       message: response.data.message,
      //       dismissCountDown: 0
      //     });
      //   }
      //   this.loading = false;
      //   this.closePopup();
      // })
      // .catch(function(error) {
      //   console.log(error);
      //   this.loading = false;
      // });
    },
    sendSalesInvoiceReport() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let data = {
        flag: "mail",
        project_id: this.project_details.project_id,
        user_name: localStorage.getItem("user_id"),
        company_id: company_data.company_id,
        active_page: this.active_page,
        total_page: this.total_page,
        email_id_arr: this.email_id_arr,
        email_ids: this.email_ids,
        generate_pdf_flag: "whole_page",
        project_data_flag: this.project_data_flag,
        report_name: "g_702"
      };
      if (this.user_sign_blob) {
        data.user_sign_blob = this.user_sign_blob;
      }
      if (this.customer_sign_blob) {
        data.customer_sign_blob = this.customer_sign_blob;
      }

      this.send_pdf_loading = true;
      axios
        .post("generate_report_pdf", data)
        .then(response => {
          this.email_ids_error = null;
          if (response.data.status) {
            this.email_dialog = false;
            this.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            this.preview_pdf_dialog = false;
            this.closePopup();
          } else {
            this.email_ids_error = response.data.errors["email_ids"];
          }
          this.send_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.send_pdf_loading = false;
        });
    },
    // getReportDetails() {
    //   let _self = this;
    //   this.loading = true;
    //   axios
    //   .get("get_item_group?project_id="+this.project_details.project_id+"&project_data_flag="+this.project_data_flag)
    //   .then(response => {
    //     let response_data = response.data;
    //     _self.items = response_data.data
    //     _self.total_amt = response_data.total_amt
    //     _self.loading = false;
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //     _self.loading = false;
    //   });
    // },

    getAllInvoiceData() {
      let _self = this;
      _self.loading = true;
      axios
        .get(
          "get_all_invoice_detail?project_id=" +
            this.project_details.project_id +
            "&project_data_flag=" +
            this.project_data_flag +
            "&generate_invoice_id=" +
            _self.invoice_no +
            "&g702_change_report=" +
            this.g702_change_report +
            "&g702_change_order_id=" +
            this.change_order_id
        )
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data;
          _self.total_balance = response_data.total_balance;
          _self.total_completed = response_data.total_completed;
          _self.total_current = response_data.total_current;
          _self.total_previous = response_data.total_previous;
          _self.total_schedule = response_data.total_schedule;
          _self.project_name = response_data.project_name;
          _self.project_no = response_data.project_no;
          _self.customer_name = response_data.customer_name;
          _self.application_date = response_data.application_date;
          _self.period_to = response_data.period_to;
          _self.total_change_order = response_data.total_change_order;
          _self.total_retainage = response_data.total_retainage;
          _self.row3_g_702 = response_data.row3_g_702;
          _self.row6_g_702 = response_data.row6_g_702;
          _self.row7_g_702 = response_data.row7_g_702;
          _self.row8_g_702 = response_data.row8_g_702;
          _self.row9_g_702 = response_data.row9_g_702;
          _self.p_retainage =
            response_data.is_p_retainage === true
              ? response_data.p_retainage
              : 0;
          _self.is_p_retainage = response_data.is_p_retainage;
          _self.contract_date = response_data.contract_date;
          _self.sales_income = response_data.sales_income;
          _self.sales_income_till_date = response_data.sales_income_till_date;
          _self.only_change_order = response_data.only_change_order;
          _self.original_contract_sum = response_data.original_contract_sum;
          _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getInvoiceList() {
      let _self = this;
      axios
        .get(
          "get_project_invoice_list?project_id=" +
            this.project_details.project_id
        )
        .then(response => {
          let response_data = response.data;
          response_data.invoice_list.map(function(item) {
            _self.invoice_list.unshift(item);
          });

          if (_self.invoice_id) {
            _self.invoice_no = _self.invoice_id ? _self.invoice_id : "0";
          } else {
            _self.invoice_no = response_data.last_invoice
              ? response_data.last_invoice
              : "0";
          }

          _self.getAllInvoiceData();
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getChangeOrderList() {
      let _self = this;
      axios
        .get(
          "get_project_change_order_list?project_id=" +
            this.project_details.project_id +
            "&get_all=true"
        )
        .then(response => {
          let response_data = response.data;
          response_data.change_order_list.map(function(item, index) {
            if (index == 0) {
              _self.change_order_id = item.change_order;
            }
            _self.change_order_list.push(item);
          });
          _self.getAllInvoiceData();
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    }
  },

  created: function() {},
  mounted: function() {
    this.change_order_list = [];
    this.invoice_list = [
      {
        amount: "0",
        invoice_number: "0",
        generated_inv_id: "0"
      }
    ];

    // this.$refs.userSignaturePad.openSignaturePad();
    // this.$refs.customerSignaturePad.openSignaturePad();
  }
};
</script>
 
 <style>
.sales-invoice-report p {
  margin-bottom: 0px;
}
.v-dialog__content {
  height: 85% !important;
  top: 50px;
  position: fixed;
}
@media only screen and (min-width: 1366px) and (orientation: landscape) {
  .v-dialog__content {
    height: 85% !important;
    top: 50px;
    position: fixed;
  }
}

/*Portrait*/
@media only screen and (min-width: 1024px) and (orientation: portrait) {
  .v-dialog__content {
    height: 68% !important;
    top: 50px;
    position: fixed;
  }
}
</style>
 